<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    fill="none"
    stroke="currentColor"
    stroke-width="2.2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle
      cx="16"
      cy="16"
      r="11"
      fill="currentColor"
      fill-opacity=".18"
      stroke="currentColor"
    />
    <path
      d="M16 7 L19 16 L16 25 L13 16 Z"
      fill="currentColor"
      stroke="none"
    />
    <circle
      cx="16"
      cy="16"
      r="1.6"
      fill="#fff"
      stroke="none"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconIntentOpen',
  props: { size: { type: [String, Number], default: 22 } },
};
</script>
